import { buildSchema, buildProperty, ExportMappingFunction } from "@camberi/firecms";
import { BlogEntryPreview } from "../custom_schema_view/BlogEntryPreview";

/**
 * This is a schema that is generated without passing an explicit type,
 * but it is inferred correctly since we are using `buildProperty` in each property
 */
export const customThemeColorSchema = buildSchema({
    name: "Custom Theme Color",
    views: [{
        path: "preview",
        name: "Preview",
        builder: (props) => <BlogEntryPreview {...props} />
    }],
    properties: {
        background: buildProperty({
            title: "Background",
            dataType: "string"
        }),
        error: buildProperty({
            title: "Error",
            dataType: "string"
        }),
        hintColor: buildProperty({
            title: "HintColor",
            dataType: "string"
        }),
        indicatorColor: buildProperty({
            title: "Indicator Color",
            dataType: "string"
        }),
        inversePrimary: buildProperty({
            title: "Inverse Primary",
            dataType: "string"
        }),
        inverseSurface: buildProperty({
            title: "Inverse Surface",
            dataType: "string"
        }),
        onBackground: buildProperty({
            title: "onBackground",
            dataType: "string"
        }),
        onError: buildProperty({
            title: "onError",
            dataType: "string"
        }),
        onPrimary: buildProperty({
            title: "onPrimary",
            dataType: "string"
        }),
        onPrimaryContainer: buildProperty({
            title: "onPrimaryContainer",
            dataType: "string"
        }),
        onSecondary: buildProperty({
            title: "onSecondary",
            dataType: "string"
        }),
        onSecondaryContainer: buildProperty({
            title: "onSecondaryContainer",
            dataType: "string"
        }),
        onSurface: buildProperty({
            title: "onSurface",
            dataType: "string"
        }),
        onSurfaceVariant: buildProperty({
            title: "onSurfaceVariant",
            dataType: "string"
        }),
        onTertiary: buildProperty({
            title: "onTertiary",
            dataType: "string"
        }),
        onTertiaryContainer: buildProperty({
            title: "onTertiaryContainer",
            dataType: "string"
        }),
        outline: buildProperty({
            title: "outline",
            dataType: "string"
        }),
        primary: buildProperty({
            title: "primary",
            dataType: "string"
        }),

        primaryContainer: buildProperty({
            title: "primaryContainer",
            dataType: "string"
        }),
        scrollbarColor: buildProperty({
            title: "scrollbarColor",
            dataType: "string"
        }),
        secondary: buildProperty({
            title: "secondary",
            dataType: "string"
        }),
        secondaryContainer: buildProperty({
            title: "secondaryContainer",
            dataType: "string"
        }),
        shadow: buildProperty({
            title: "shadow",
            dataType: "string"
        }),
        surface: buildProperty({
            title: "surface",
            dataType: "string"
        }),
        surfaceVariant: buildProperty({
            title: "surfaceVariant",
            dataType: "string"
        }),
        tertiary: buildProperty({
            title: "tertiary",
            dataType: "string"
        }),
        tertiaryContainer: buildProperty({
            title: "tertiaryContainer",
            dataType: "string"
        }),

        
    },
    defaultValues: {
        status: "draft",
        order: 0
    }
});

export const customThemeStringsSchema = buildSchema({
    name: "Custom Theme Strings",
    views: [{
        path: "preview",
        name: "Preview",
        builder: (props) => <BlogEntryPreview {...props} />
    }],
    properties: {
        appName: buildProperty({
            title: "App Name",
            dataType: "string"
        }),
        appId: buildProperty({
            title: "App Id",
            dataType: "number"
        }),
        appLogo: buildProperty({
            title: "App Logo",
            dataType: "string"
        }),
        app_store_link: buildProperty({
            title: "App Store Link",
            dataType: "string"
        }),
        clearcacheUrl: buildProperty({
            title: "Clear Cache Url",
            dataType: "string"
        }),
        coachName: buildProperty({
            title: "Coach Name",
            dataType: "string"
        }),
        referral_point_enable: buildProperty({
            title: "Enable Referral",
            dataType: "boolean",
            columnWidth: 250,
        }),
        referral_point: buildProperty({
            title: "Referral Points",
            dataType: "number",
        }),
        referral_point_discount:buildProperty({
            title: "Referral Point Discount",
            dataType: "number",
            columnWidth: 250,
        }),
        referral_discount_amount:buildProperty({
            title: "Referral Discount Amount",
            dataType: "number",
            columnWidth: 250,
        }),
        copyRight: buildProperty({
            title: "Copyright",
            dataType: "string"
        }),
        defaultImage: buildProperty({
            title: "Default Image",
            dataType: "string"
        }),
        fallbackUrl: buildProperty({
            title: "Fallback Url",
            dataType: "string"
        }),
        networkImagePlaceholder: buildProperty({
            title: "Network Image Placeholder",
            dataType: "string"
        }),
        nutrition_title: buildProperty({
            title: "Nutrition Title",
            dataType: "string"
        }),
        playstore_link: buildProperty({
            title: "Play Store Link",
            dataType: "string"
        }),
        webUrl: buildProperty({
            title: "Web Url",
            dataType: "string"
        }),

        ownerEmail: buildProperty({
            title: "Owner Email",
            dataType: "string"
        }),

        showQA: buildProperty({
            title: "Show QA",
            dataType: "boolean"
        }),
        showSignup: buildProperty({
            title: "Show Signup",
            dataType: "boolean"
        }),
        show_home: buildProperty({
            title: "Show Home",
            dataType: "boolean"
        }),
        show_blog: buildProperty({
            title: "Show Blog",
            dataType: "boolean"
        }),
        show_community: buildProperty({
            title: "Show Community",
            dataType: "boolean"
        }),
        show_recipe: buildProperty({
            title: "Show Recipe",
            dataType: "boolean"
        }),
        singup_status_on_mobile: buildProperty({
            title: "Signup Status On Mobile",
            dataType: "boolean"
        }),
        inapp_purchase: buildProperty({
            title: "In App Purchase",
            dataType: "boolean"
        }),
        show_library: buildProperty({
            title: "Show library",
            dataType: "boolean"
        }),
        show_library_category: buildProperty({
            title: "Show library Category",
            dataType: "boolean"
        }),
        splash_initial_text: buildProperty({
            title: "Splash Screen Initial Text",
            dataType: "string"
        }),
        transformation_title: buildProperty({
            title: "Transaformation Title",
            dataType: "string"
        }),
        showNutritionFilter: buildProperty({
            title: "Show Nutrition Filter",
            dataType: "boolean"
        }),

        isGreg: buildProperty({
            title: "Is Greg",
            dataType: "boolean"
        }),

        disable_google: buildProperty({
            title: "Disable Google",
            dataType: "boolean"
        }),

        enable_referral: buildProperty({
            title: "Enable Referral",
            dataType: "boolean"
        }),

        hasOneToOne: buildProperty({
            title: "Has One To One",
            dataType: "boolean"
        }),

        showLoginVideo: buildProperty({
            title: "Show Login Video",
            dataType: "boolean"
        }),

        login_over_image_text: buildProperty({
            title: "Login Over Image Text",
            dataType: "string"
        }),

        login_screen_text: buildProperty({
            title: "Login Screen Text",
            dataType: "string"
        }),
        
        isMacroHide: buildProperty({
            title: "Is Macro Hide",
            dataType: "boolean"
        }),

        show_shop: buildProperty({
            title: "Show Shop",
            dataType: "boolean"
        }),

    },
    defaultValues: {
        status: "draft",
        order: 0,
        referral_point: 10,
        show_home: true,
        show_community: true,
        show_recipe: true,
    }
});

/**
 * Sample field that will be added to the export
 */
export const sampleAdditionalExportColumn: ExportMappingFunction = {
    key: "extra",
    builder: async ({ entity }) => {
        await new Promise(resolve => setTimeout(resolve, 100));
        return "Additional exported value " + entity.id;
    }
};